import WIDGETS from './widgets';

export default {
	name: 'article_overview',
	spacing: 2,
	widgets: [{ content: WIDGETS.ARTICLE_VIEW, breakpoints: { xs: 12 } }],
};